export const ENVD_VERSION_RECURSIVE_WATCH = '0.1.4'